export const hexToBinary = (str: string) => {
    const halfLength = str.length >>> 1
    const bytes = new Uint8Array(halfLength)
    for (let k = 0; k < halfLength; ++k) {
        bytes[k] = Number.parseInt(str.substr(k << 1, 2), 16)
    }
    return String.fromCharCode(...bytes)
}
